import React from "react";
import MinMaxNumberValidator from "../../../common/input-validators/MinMaxNumberValidator";
import { Calculation } from "../../../../../src/application/Contracts";
import InstallationType = Calculation.InstallationType;
import BaseInputValidator from "../../../common/input-validators/BaseInputValidator";
import Field from "../../../../model/configurator/Field";

interface SelfProps {
    selectedInstallationType: number;
    renderField: (field: any, additionalProps?: object, validator?: BaseInputValidator | undefined) => any,
    fields: { [key: string]: Field },
    readonly?: boolean
}

export class CalculateMethod extends React.Component<SelfProps> {
    showForInstallationType = (installationType: InstallationType, selectedType: number | undefined = undefined): boolean => {
        return (selectedType ?? this.props.selectedInstallationType) === installationType;
    }
    renderField = (field: any, additionalProps?: object, validator?: BaseInputValidator | undefined) => {
        const props = this.props.readonly ? { ...additionalProps, readonly: true, description: '' } : additionalProps;
        return this.props.renderField(field, props, validator)
    }
    renderApartmentsInputs = () => {
        return <React.Fragment>
            {this.renderField(this.props.fields.park)}
            {this.renderField(this.props.fields.standing)}
            {this.renderField(this.props.fields.situation)}
        </React.Fragment>
    }

    renderInternatsInputs = () => {
        return <React.Fragment>
            {this.renderField(this.props.fields.numberOfBeds)}
            {this.renderField(this.props.fields.numberOfShowerRooms)}
            {this.renderField(this.props.fields.numberOfShowersPerShowerRoom)}
            {this.renderField(this.props.fields.showerConsumption)}
            {this.renderField(this.props.fields.showerMeanDuration)}
            {this.renderField(this.props.fields.pushButtons)}
        </React.Fragment>
    }
    renderRestaurantsInputs = () => {
        return <React.Fragment>
            {this.renderField(this.props.fields.restaurantCategory)}
            {this.renderField(this.props.fields.numberMealsBreakfast)}
            {this.renderField(this.props.fields.numberMealsLunch)}
            {this.renderField(this.props.fields.numberMealsDinner)}
        </React.Fragment>
    }
    renderHotelsInputs = () => {
        return <React.Fragment>
            {this.renderField(this.props.fields.numberOfRooms)}
            {this.renderField(this.props.fields.hotelStanding)}
            {this.renderField(this.props.fields.mountain)}
        </React.Fragment>
    }
    renderHospitalsInputs = () => {
        return <React.Fragment>
            {this.renderField(this.props.fields.numberOfRooms)}
            {this.renderField(this.props.fields.bedsPerRoom, {}, new MinMaxNumberValidator(1, 5))}
        </React.Fragment>
    }
    renderRetirementsInputs = () => {
        return <React.Fragment>
            {this.renderField(this.props.fields.numberOfRooms)}
        </React.Fragment>
    }
    renderCampingInputs = () => {
        return <React.Fragment>
            {this.renderField(this.props.fields.numberOfRooms, { label: "Number of spaces" })}
            {this.renderField(this.props.fields.campingClassification)}
            {this.renderField(this.props.fields.campingSituation)}
        </React.Fragment>
    }
    renderSportCentersInputs = () => {
        return <React.Fragment>
            <div />
            {this.renderField(this.props.fields.sportCenterGymnasiumNumberOfSportHalls)}
            {this.renderField(this.props.fields.sportCenterStadiumNumberOfSportGrounds)}
            {this.renderField(this.props.fields.numberOfShowerRooms)}
            {this.renderField(this.props.fields.numberOfShowersPerShowerRoom)}
            {this.renderField(this.props.fields.showerConsumption)}
            {this.renderField(this.props.fields.showerMeanDuration)}
            {this.renderField(this.props.fields.pushButtons)}
        </React.Fragment>
    }

    temperatureItems = () => {
        return { items: [{ value: 60, text: "60 °C" }, { value: 55, text: "55 °C" },] }
    }


    renderReadonly = () => {
        return <div className={`step-inputs-row`}>
            {this.showForInstallationType(InstallationType.SportCenters) && this.renderField(this.props.fields.maxChargingTimeForAccumulationSportCenters, { label: "Max time between 2 matches" })}
            {this.showForInstallationType(InstallationType.Restaurants) && this.renderField(this.props.fields.maxChargingTimeForAccumulationSportCenters, { label: "Time between 2 services (hrs)" })}
            {this.renderField(this.props.fields.tDhw, this.temperatureItems(), new MinMaxNumberValidator(50, 80))}
            {this.showForInstallationType(InstallationType.ApartmentsBlocks) && this.renderApartmentsInputs()}
            {this.showForInstallationType(InstallationType.Internats) && this.renderInternatsInputs()}
            {this.showForInstallationType(InstallationType.Restaurants) && this.renderRestaurantsInputs()}
            {this.showForInstallationType(InstallationType.Hotels) && this.renderHotelsInputs()}
            {this.showForInstallationType(InstallationType.Hospitals) && this.renderHospitalsInputs()}
            {this.showForInstallationType(InstallationType.Retirement) && this.renderRetirementsInputs()}
            {this.showForInstallationType(InstallationType.Campings) && this.renderCampingInputs()}
            {this.showForInstallationType(InstallationType.SportCenters) && this.renderSportCentersInputs()}
        </div>
    }

    render() {
        if (this.props.readonly) {
            return this.renderReadonly();
        }
        return <>
            {this.showForInstallationType(InstallationType.SportCenters) &&
                <div className={`step-inputs-row`}>{this.props.renderField(this.props.fields.maxChargingTimeForAccumulationSportCenters, { label: "Max time between 2 matches" })}</div>}
            {this.showForInstallationType(InstallationType.Restaurants) &&
                <div className={`step-inputs-row`}>{this.props.renderField(this.props.fields.maxChargingTimeForAccumulationRestaurants, { label: "Time between 2 services (hrs)" })}</div>}
            <div className={`step-inputs-row`}>
                {this.renderField(this.props.fields.tDhw, this.temperatureItems(), new MinMaxNumberValidator(50, 80))}
                {this.showForInstallationType(InstallationType.ApartmentsBlocks) && this.renderApartmentsInputs()}
                {this.showForInstallationType(InstallationType.Internats) && this.renderInternatsInputs()}
                {this.showForInstallationType(InstallationType.Restaurants) && this.renderRestaurantsInputs()}
                {this.showForInstallationType(InstallationType.Hotels) && this.renderHotelsInputs()}
                {this.showForInstallationType(InstallationType.Hospitals) && this.renderHospitalsInputs()}
                {this.showForInstallationType(InstallationType.Retirement) && this.renderRetirementsInputs()}
                {this.showForInstallationType(InstallationType.Campings) && this.renderCampingInputs()}
                {this.showForInstallationType(InstallationType.SportCenters) && this.renderSportCentersInputs()}
            </div>
        </>;
    }
}